var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.sheet.closed ? "locked" : "",
        "tab-" + _vm.tabState,
        _vm.subState,
        _vm.anonymousMode ? "anonymous" : ""
      ],
      attrs: { id: "wow-sheet" }
    },
    [
      _vm.selection.length > 0
        ? _c(
            "div",
            { staticClass: "toolbar fixed-top d-flex align-items-center px-3" },
            [
              _c("icon-button", {
                staticClass: "mr-2",
                attrs: { name: "close" },
                on: {
                  click: function($event) {
                    _vm.clearSelection()
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$formatMessage("selection-count", {
                      count: _vm.selection.length
                    })
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-auto" },
                [
                  _c("icon-button", {
                    attrs: { name: "delete", disabled: _vm.deleting },
                    on: { click: _vm.deleteSelection }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.sheet.isOpen
        ? _c(
            "button",
            { staticClass: "btn-fab", on: { click: _vm.showEdit } },
            [_c("i", { staticClass: "icon-add" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }, [
        _c(
          "div",
          { staticClass: "col-left" },
          [
            !_vm.loading
              ? _c("div", [
                  _vm.items.length === 0
                    ? _c("div", {
                        directives: [
                          {
                            name: "i18n",
                            rawName: "v-i18n",
                            value: "expenses_void",
                            expression: "'expenses_void'"
                          }
                        ],
                        staticClass: "card card-body"
                      })
                    : _c("button", {
                        directives: [
                          {
                            name: "i18n",
                            rawName: "v-i18n",
                            value: "sheet_counters_button",
                            expression: "'sheet_counters_button'"
                          }
                        ],
                        staticClass: "btn btn-link balance",
                        on: { click: _vm.showBalance }
                      })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              {
                ref: "rowsList",
                staticClass: "list-group list-transactions",
                class: [_vm.loading ? "mb-0" : ""]
              },
              _vm._l(_vm.items, function(item) {
                return _c(
                  "li",
                  {
                    key: item.row.id,
                    staticClass: "list-group-item",
                    class: [
                      { "bg-selected": item.selected },
                      { "bg-edited": item.edited }
                    ],
                    attrs: { "data-id": item.row.id }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "circle",
                        class: [{ selected: item.selected }]
                      },
                      [
                        item.selected || item.checkboxVisible
                          ? _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: { checked: item.selected }
                            })
                          : _c("avatar", { attrs: { booker: item.row.booker } })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "amount bg-edited-child bg-selected-child"
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm._f("format-currency")(
                                item.row.amount,
                                _vm.currency
                              )
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row w-100" }, [
                      _c(
                        "div",
                        {
                          staticClass: "text-truncate col-10",
                          class: item.splitType === "default" ? "" : "col-sm-5"
                        },
                        [
                          _vm._v(
                            _vm._s(item.row.booker.name) + "\n\t\t\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4 d-none d-xl-block pl-0" },
                        [
                          _c("expense-split-badge", {
                            staticClass: "my-auto",
                            attrs: { item: item }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-secondary w-100" },
                      [
                        item.row.description
                          ? _c("user-text", {
                              staticClass: "float-left",
                              attrs: { text: item.row.description }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "float-right" },
                          [
                            _c("expense-split-badge", {
                              staticClass: "d-xl-none",
                              attrs: { item: item }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text-small",
                                attrs: {
                                  title: _vm.$formatMessage("expense_ctime", {
                                    ctime: item.row.ctime
                                  })
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("format-date")(item.row.ctime)
                                  ) + "\n\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              })
            ),
            _vm._v(" "),
            !_vm.allEntitiesLoaded
              ? _c("loading-spacer", { staticClass: "mt-0" })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-right" }, [
          _c(
            "div",
            [
              _c("expense-editor", {
                ref: "expenseEditor",
                attrs: {
                  sheet: _vm.sheet,
                  "row-id": _vm.editedRowId,
                  disabled: _vm.sheet.closed
                },
                on: { cancelled: _vm.onEditCancelled, saved: _vm.onEditSaved }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sheet-balance-wrapper top-header" },
                [
                  _c("sheet-balance", {
                    attrs: {
                      sheetKey: _vm.sheet.key,
                      balance: _vm.sheet.balance,
                      currency: _vm.sheet.parent.currency
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("ul", { staticClass: "tabs tabs-up" }, [
                _c("li", {
                  directives: [
                    {
                      name: "i18n",
                      rawName: "v-i18n",
                      value: "sheet_edit_tab",
                      expression: "'sheet_edit_tab'"
                    }
                  ],
                  class: { active: _vm.tabState === "edit" },
                  on: {
                    click: function($event) {
                      _vm.showTab("edit")
                    }
                  }
                }),
                _vm._v(" "),
                _c("li", {
                  directives: [
                    {
                      name: "i18n",
                      rawName: "v-i18n",
                      value: "sheet_counters_tab",
                      expression: "'sheet_counters_tab'"
                    }
                  ],
                  class: { active: _vm.tabState === "counters" },
                  on: {
                    click: function($event) {
                      _vm.showTab("counters")
                    }
                  }
                })
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e75a60a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e75a60a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/sheet-expenses.vue
// module id = DZg8
// module chunks = 3